export default function reducer(state = {
  fetching: false,
  fetched: false,
  errors: {},
  messages: []
}, action) {
  switch (action.type) {
    case 'GET_MESSAGES_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_MESSAGES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        messages: action.payLoad.data,
      }
    }
    case 'MARK_MESSAGES_FULFILLED': {
      const messages = [...state.messages];
      messages.forEach(message => {
        if(action.payLoad.messageIds.find(id => id === message.id)){
          message.attributes.read = action.payLoad.read;
        }
      });

      return {
        ...state,
        messages: messages
      }
    }
    case 'DELETE_MESSAGES_FULFILLED': {
      const messages = state.messages.filter(message => !action.payLoad.messageIds.find(id => id === message.id));

      return {
        ...state,
        messages: messages
      }
    }
    case 'GET_MESSAGES_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'GET_UNREAD_MESSAGE_COUNT': {
      return {...state, unreadMessagesCount: action.payLoad.unread_messages}
    }
    default:
  }

  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/messagesReducer.js